import * as React from 'react';

import { TaxonomyListDataService } from 'src/app/general/taxonomies/list/taxonomy-list.data';
import { TaxonomyEditorView } from './taxonomy-editor.view';

interface Props {
	value: string | null;
	mode: ControlMode;
	onChange: (value: TaxonomySummary | null) => void;
	setBusy: (isBusy: boolean) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class TaxonomyEditorController extends React.Component<Props, {}> {
	dataService: TaxonomyListDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.dataService = TaxonomyListDataService.make();
	}

	taxonomyQuery = (keywords?: string): Promise<QueryResult<TaxonomySummary>> => {
		return new Promise<QueryResult<TaxonomySummary>>((resolve, reject) => {
			this.props.setBusy(true);

			this.dataService.addFilter('isDeleted', 'eq', false);
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.searchKeywords = keywords;
			this.dataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.dataService.count
					});
				});
		});
	};

	render() {
		return (
			<TaxonomyEditorView
				taxonomyRequest={{ query: this.taxonomyQuery, dataSet: this.dataService }}
				{...this.props}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/parts/taxonomy-editor.controller.tsx